import { library } from '@fortawesome/fontawesome-svg-core'
import { faMinus, faPlus, faTrash, faTimes, faWrench, faCheck, faListAlt } from '@fortawesome/free-solid-svg-icons'
/*import { } from '@fortawesome/pro-regular-svg-icons'
import { } from '@fortawesome/pro-light-svg-icons'*/

library.add(faMinus, faPlus, faTrash, faTimes, faWrench, faCheck, faListAlt);